import { ensureNumber } from 'utilities/isType.js';

// These colors come from `variables.scss`. See $rain-light and the others.
const RAINFALL_NONE_COLOR = '#bfcdef';
const RAINFALL_LIGHT_COLOR = '#bfcdef';
const RAINFALL_MODERATE_COLOR = '#6e8cd6';
const RAINFALL_HEAVY_COLOR = '#324ba7';
const RAINFALL_TORRENTIAL_COLOR = '#04127a';

export const calculateRainfall = (
  rainfall: number | string,
): 'none' | 'light' | 'moderate' | 'heavy' | 'torrential' => {
  const finalRainfall = ensureNumber(rainfall);
  // @NOTE These are based on current MetService implementation
  // None:        < 0.1mm
  // Light:       0.1mm - 2.0mm
  // Moderate:    2.1mm - 6.0mm
  // Heavy:       6.1mm - 25mm
  // Torrential:  > 25mm

  if (finalRainfall > 25) {
    return 'torrential';
  } else if (finalRainfall > 6) {
    return 'heavy';
  } else if (finalRainfall > 2) {
    return 'moderate';
  } else if (finalRainfall > 0.1) {
    return 'light';
  }

  return 'none';
};

export const getColourForRainfall = (rainfall: number | string): '#04127a' | '#324ba7' | '#6e8cd6' | '#bfcdef' => {
  const finalRainfall = ensureNumber(rainfall);

  if (finalRainfall > 25) {
    return RAINFALL_TORRENTIAL_COLOR;
  } else if (finalRainfall > 6) {
    return RAINFALL_HEAVY_COLOR;
  } else if (finalRainfall > 2) {
    return RAINFALL_MODERATE_COLOR;
  } else if (finalRainfall > 0.1) {
    return RAINFALL_LIGHT_COLOR;
  }

  return RAINFALL_NONE_COLOR;
};
